import { scopedCreator } from 'ha/myredux/createAction';
import { ACTIONS_PREFIX } from '../constants';

const createAction = scopedCreator(ACTIONS_PREFIX);

export const archive = createAction.request('archive');

export default (conversationID, flagArchived) => (dispatch, _, { apiV2 }) =>
  apiV2
    .toggleArchiveConversation(conversationID, flagArchived)
    .then(() => dispatch(archive.done({ conversationID, flagArchived })))
    .catch(error => dispatch(archive.error(error)));
